import React from 'react';
import { Box, UnderlineNav } from "@primer/react";
import { GearIcon, IdBadgeIcon,PeopleIcon ,FileDirectoryIcon,GiftIcon, LinkExternalIcon    } from "@primer/octicons-react";

type OcticonType = typeof IdBadgeIcon;

interface PhuHuynhProfileTabProps {
  id: string;
  name: string;
  icon: OcticonType;  
  description: string;
}

interface PhuHuynhProfileListTabProps {
  selectedTab: string;
  onTabSelectionChanged: (id: string) => void;
  PhuHuynhId: number;
}

export const PhuHuynhProfileTabs: PhuHuynhProfileTabProps[] = [
  { id: "dashboard", name: "Thông tin chung", icon: IdBadgeIcon, description: "Thông tin chung" },
  //{ id: "care", name: "Thêm lịch sử chăm sóc", icon: FileDirectoryIcon, description: "Thông tin lịch sử chăm sóc" },
  { id: "student", name: "Thêm học sinh", icon:PeopleIcon, description: "Thông tin học sinh" },
  //{ id: "service", name: "Dịch vụ", icon:LinkExternalIcon, description: "Thông tin các dịch vụ học sinh đăng ký" },
];

const PhuHuynhProfileListTab: React.FC<PhuHuynhProfileListTabProps> = ({ selectedTab, onTabSelectionChanged, PhuHuynhId }) => {
  return (
    <Box>
      <UnderlineNav aria-label="tabs">
        {PhuHuynhProfileTabs
          .filter((tab) => PhuHuynhId > 0 || tab.id === "dashboard")
          .map((tab) => (

            <UnderlineNav.Item
              key={tab.id}
              icon={tab.icon}
              aria-current={tab.id === selectedTab ? "page" : undefined}
              onClick={() => onTabSelectionChanged(tab.id)}
            >
              {tab.name}
            </UnderlineNav.Item>
          ))}
      </UnderlineNav>
    </Box>
  );
};

export default PhuHuynhProfileListTab;